import { styled, Typography } from '@mui/material';

export const StyledDescription = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.textSm.fontSize,
  color: theme.palette.title.main,
}));
